export const rupiah = (n) =>
  new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(n || 0);

export const fmtDate = (s) =>
  s ? new Date(s).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" }) : "-";

export const fmtDateTime = (s) =>
  s
    ? new Date(s).toLocaleString("id-ID", { weekday: "short", day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })
    : "-";

export const youtubeId = (url) => {
  const m = (url || "").match(/(?:youtu\.be\/|v=|embed\/|shorts\/|live\/)([\w-]{11})/);
  return m ? m[1] : null;
};

export const isPackageActive = (u) => !!(u?.package_id && u?.package_expires_at && new Date(u.package_expires_at) > new Date());

export const daysLeft = (s) => (s ? Math.max(0, Math.ceil((new Date(s) - new Date()) / 86400000)) : 0);

export const PAYMENT_STATUS = {
  menunggu_pembayaran: { label: "Menunggu Pembayaran", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  menunggu_verifikasi: { label: "Menunggu Verifikasi", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  disetujui: { label: "Disetujui", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  ditolak: { label: "Ditolak", cls: "bg-red-50 text-red-700 border-red-200" },
};

export const ATTENDANCE_STATUS = {
  hadir: "bg-emerald-50 text-emerald-700 border-emerald-200",
  izin: "bg-sky-50 text-sky-700 border-sky-200",
  sakit: "bg-violet-50 text-violet-700 border-violet-200",
  alpa: "bg-red-50 text-red-700 border-red-200",
};
